export default __webpack_public_path__ + "media/images/icons/consultancy-filled-4f830f33faf872c3df80522d6d6c6149.svg";